<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow': control.elementVal.getValue()?.duringChange === 't' }"></div>
    <img class="control__img bg-style border-light"
         [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__icon': control.elementVal.getValue()?.duringChange === 'f' }"
         ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
         width="72" height="72" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>
    <div class="control__content control__group-checkbox color-basic">
        <span class="control__outter"
            [ngClass]="{ 'control__outter--expanded': inputBox.showWiki }">
            <div class="control__checkbox-label"
                *ngFor="let val of inputBox.checkboxTable; let key = index">
                <input class="control__checkbox-input  cursor-pointer"
                    id="id{{key}}"
                    type="checkbox"
                    [value]="val.value"
                    [(ngModel)]="val.checked"
                    (click)="inputBox.setCheckBox(val.value)">
                <label class="control__checkbox-name cursor-pointer" for="id{{key}}"
                    [ngClass]="control.setCheckboxIconByCompany(val.checked)">
                    {{ subtitle(val.txtId) }}
                </label>
                <img class="control__wiki-icon cursor-pointer"
                    *ngIf="control.elementVal.getValue()?.duringChange !== 't' && val.wikiTxtId > 0"
                    ngSrc="/assets/img/icons/question_checkbox.svg"
                    width="33" height="33" alt="" />
                <div class="control__wiki-container bg-wiki">
                    <p class="control__wiki-item color-light font-12">
                        {{ subtitle(val.wikiTxtId) }}
                    </p>
                </div>
            </div>
            <div class="control__wiki-wrapper bg-light"
                 *ngIf="control.elementVal.getValue()?.duringChange !== 't' && inputBox.showWiki"></div>
        </span>
    </div>
    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
            data-testid="resetButton"
            (click)="inputBox.setCheckBox(control.elementVal.getValue()?.params.default)">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/return.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                'bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="sendButton"
                (click)="inputBox.returnExpandedCheckbox(getMenuElement())">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/ok.svg"
                width="40" height="40" alt="" />
        </button>
    </div>
    <div *ngIf="control.elementVal.getValue()?.duringChange === 't'"
        class="control__during-change">
        <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
    </div>
</div>
